module.exports = __webpack_public_path__ + "static/media/WU_STEPS_review_active.6a21524f.svg";